import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import UploadAvatars from './UploadAvatars';
import ClientProvider from './client';
export default createDemo(import.meta.url, UploadAvatars, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/avatars/demos/upload/UploadAvatars.tsx",
    "fileName": "UploadAvatars.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Avatar from '@mui/material/Avatar';\nimport ButtonBase from '@mui/material/ButtonBase';\n\nexport default function UploadAvatars() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [avatarSrc, setAvatarSrc] = React.useState<string | undefined>(undefined);\n\n  const handleAvatarChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    const file = event.target.files?.[0];\n    if (file) {\n      // Read the file as a data URL\n      const reader = new FileReader();\n      reader.onload = () => {\n        setAvatarSrc(reader.result as string);\n      };\n      reader.readAsDataURL(file);\n    }\n  };\n\n  return (\n    <ButtonBase\n      component=\"label\"\n      role={undefined}\n      tabIndex={-1} // prevent label from tab focus\n      aria-label=\"Avatar image\"\n      sx={{\n        borderRadius: '40px',\n        '&:has(:focus-visible)': {\n          outline: '2px solid',\n          outlineOffset: '2px',\n        },\n      }}\n    >\n      <Avatar alt=\"Upload new avatar\" src={avatarSrc} />\n      <input\n        type=\"file\"\n        accept=\"image/*\"\n        style={{\n          border: 0,\n          clipPath: 'inset(50%)',\n          height: '1px',\n          margin: '-1px',\n          overflow: 'hidden',\n          padding: 0,\n          position: 'absolute',\n          whiteSpace: 'nowrap',\n          width: '1px',\n        }}\n        onChange={handleAvatarChange}\n      />\n    </ButtonBase>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 53,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Avatar from '@mui/material/Avatar';\nimport ButtonBase from '@mui/material/ButtonBase';\n\nexport default function UploadAvatars() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [avatarSrc, setAvatarSrc] = React.useState<string | undefined>(undefined);\n\n  const handleAvatarChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    const file = event.target.files?.[0];\n    if (file) {\n      // Read the file as a data URL\n      const reader = new FileReader();\n      reader.onload = () => {\n        setAvatarSrc(reader.result as string);\n      };\n      reader.readAsDataURL(file);\n    }\n  };\n\n  return (\n    <ButtonBase\n      component=\"label\"\n      role={undefined}\n      tabIndex={-1} // prevent label from tab focus\n      aria-label=\"Avatar image\"\n      sx={{\n        borderRadius: '40px',\n        '&:has(:focus-visible)': {\n          outline: '2px solid',\n          outlineOffset: '2px',\n        },\n      }}\n    >\n      <Avatar alt=\"Upload new avatar\" src={avatarSrc} />\n      <input\n        type=\"file\"\n        accept=\"image/*\"\n        style={{\n          border: 0,\n          clipPath: 'inset(50%)',\n          height: '1px',\n          margin: '-1px',\n          overflow: 'hidden',\n          padding: 0,\n          position: 'absolute',\n          whiteSpace: 'nowrap',\n          width: '1px',\n        }}\n        onChange={handleAvatarChange}\n      />\n    </ButtonBase>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 53,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Avatar",
      "@mui/material/ButtonBase"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
